/**
 * Utilitaires de formatage pour l'application
 */

/**
 * Formate une date en format français
 * @param {string} dateString - La date à formater
 * @returns {string} La date formatée
 */
export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR');
};

/**
 * Formate une heure (HH:MM:SS) en format HH:MM
 * @param {string} time - L'heure à formater
 * @returns {string} L'heure formatée
 */
export const formatTime = (time) => {
  if (!time) return '';
  return time.substring(0, 5);
};

/**
 * Retourne la classe CSS pour un statut donné
 * @param {string} status - Le statut
 * @returns {string} La classe CSS
 */
export const getStatusBadge = (status) => {
  const statusColors = {
    'PROGRAMME': 'bg-blue-100 text-blue-800',
    'EN_COURS': 'bg-yellow-100 text-yellow-800',
    'TERMINE': 'bg-green-100 text-green-800',
    'ANNULE': 'bg-red-100 text-red-800'
  };
  return statusColors[status] || 'bg-blue-100 text-blue-800';
};

/**
 * Vérifie si une session est terminée
 * @param {Object} session - La session à vérifier
 * @returns {boolean} true si la session est terminée
 */
export const isSessionTerminee = (session) => {
  if (!session.date_examen || !session.heure_fin) return false;
  
  const now = new Date();
  const sessionDate = new Date(session.date_examen);
  const [heures, minutes] = session.heure_fin.split(':');
  sessionDate.setHours(parseInt(heures), parseInt(minutes), 0, 0);
  
  return now > sessionDate;
}; 